export {
  sortAreas,
  sortClasses,
  filterData
};

function sortAreas(a, b) {
  return b.pov_3_ha - a.pov_3_ha;
}

function sortClasses(a, b) {
  return a.kod_3 - b.kod_3;
}

function filterData(data, col, id) {
  return data.filter( row => {
    return row[col] == id ; // must be loose equal ('==')
  });
}
